export function TorontoOverview() {
  const keyPoints = [
    {
      icon: "ri-home-4-line",
      title: "Principal Residence Only",
      description:
        "You can only operate an STR in your principal residence - where you live for at least 6 months per year.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "City Registration Required",
      description:
        "All STR operators must register with the City of Toronto and display their registration number.",
    },
    {
      icon: "ri-calendar-line",
      title: "180-Night Annual Cap",
      description:
        "Entire home rentals are limited to 180 nights per year when you are not present. Private rooms have no night limit.",
    },
    {
      icon: "ri-percent-line",
      title: "8.5% MAT Collection",
      description:
        "Operators must collect and remit the 8.5% Municipal Accommodation Tax on all bookings.",
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Regulatory Overview
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Understanding Toronto&apos;s STR Framework
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Toronto&apos;s regulations focus on preserving long-term housing while allowing residents to subsidize their own costs. Here&apos;s what you need to know for 2026.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {keyPoints.map((point, index) => (
            <div
              key={index}
              className="bg-[#F8F8F8] rounded-2xl p-8 hover:shadow-lg transition-all"
            >
              <div className="w-14 h-14 bg-[#882629]/10 rounded-xl flex items-center justify-center mb-6">
                <i className={`${point.icon} text-2xl text-[#882629]`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-3">
                {point.title}
              </h3>
              <p className="text-[#505A5A]/70 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#882629]/5 to-[#882629]/10 rounded-2xl p-8 lg:p-12">
          <div className="grid lg:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">
                $55
              </div>
              <p className="text-[#505A5A]/70">Annual Registration Fee</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">
                180 Nights
              </div>
              <p className="text-[#505A5A]/70">Max Entire Home Rentals</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">
                $100,000
              </div>
              <p className="text-[#505A5A]/70">Maximum Violation Fine</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
